/**
 * CalendarV2 Component
 * Main container for the Calendar V2 module
 * Integrates all components with context
 */

import React from 'react';
import { CalendarProvider, useCalendarState } from './context/CalendarContext';
import { useCalendarUI } from './context/CalendarUIContext';

// Components
import CalendarHeader from './components/CalendarHeader/CalendarHeader';
import FilterSection from './components/CalendarHeader/FilterSection';
import CalendarView from './components/CalendarView/CalendarView';
import UserSidebar from './components/Sidebar/UserSidebar';
import CalendarSettings from './components/Settings/CalendarSettings';
import EventViewModal from './components/EventModals/EventViewModal';
import EventFormModal from './components/EventModals/EventFormModal';
import DayEventsPopup from './components/DayEventsPopup/DayEventsPopup';

// Styles
import './styles/calendarv2.scss';

// Inner content component that can access context
const CalendarV2Content = () => {
  const { sidebarCollapsed, toggleSidebar } = useCalendarUI();
  const { isGlobal } = useCalendarState();

  return (
    <div className="calendar-v2-container">
      {/* Header */}
      {isGlobal && <CalendarHeader />}

      {/* Filters */}
      <FilterSection />

      {/* Mobile sidebar and backdrop - only for <992px */}
      {isGlobal && (
        <>
          {/* Backdrop */}
          {!sidebarCollapsed && <div className="mobile-sidebar-backdrop d-block d-lg-none" onClick={toggleSidebar} />}
          {/* Sidebar: only render when open on mobile */}
          {!sidebarCollapsed && (
            <div className="calendar-sidebar-mobile d-block d-lg-none">
              <button
                type="button"
                className="btn btn-link calendar-sidebar-close position-absolute top-0 end-0 m-2"
                aria-label="Close sidebar"
                onClick={toggleSidebar}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <UserSidebar />
            </div>
          )}
        </>
      )}

      {/* Main Content */}
      <div className={`calendar-v2-main${!sidebarCollapsed && window.innerWidth < 992 ? ' blurred' : ''}`}>
        {/* Desktop sidebar: always visible on >=992px */}
        {isGlobal && (
          <div className={`d-none d-lg-block calendar-sidebar${sidebarCollapsed ? ' collapsed' : ' expanded'}`}>
            <UserSidebar />
          </div>
        )}
        {/* Calendar */}
        <CalendarView />
      </div>

      {/* Modals */}
      <CalendarSettings />
      <EventViewModal />
      <EventFormModal />

      {/* Day Events Popup */}
      <DayEventsPopup />
    </div>
  );
};

const CalendarV2 = ({ ...props }) => {
  return (
    <CalendarProvider {...props}>
      <CalendarV2Content />
    </CalendarProvider>
  );
};

export default CalendarV2;
